<template>
  <div class="d-flex flex-column" style="min-height: 100vh">
    <!-- main -->
    <div style="flex: 1">
      <!-- logo -->
      <logo_display />
      <!-- logo -->

      <!-- heading -->
      <page_banner page_title="每月小提示" />
      <!-- heading -->

      <b-container class="mt-4">
        <!-- error message -->
        <b-container
          class="d-flex justify-content-center align-content-center my-3"
          v-if="error"
        >
          <b-alert variant="danger" show
            ><b
              ><h3>{{ error }}</h3></b
            ></b-alert
          >
        </b-container>
        <!-- error message -->

        <!-- contents -->
        <b-row
          class="d-flex justify-content-center align-content-center"
          v-else
        >
          <b-col
            v-for="(tip, index) in paginated_tips"
            :key="index"
            cols="12"
            xs="6"
            sm="6"
            md="4"
            lg="3"
            class="mb-4"
          >
            <tip_card
              :title="tip.title"
              :contents="tip.contents"
              :image="tip.image"
              :create_at="tip.create_at"
            />
          </b-col>
        </b-row>
        <div class="d-flex justify-content-center align-items-center">
          <b-pagination
            v-model="current_page"
            :total-rows="tips.length"
            :per-page="items_per_page"
          />
        </div>
        <!-- contents -->
      </b-container>
    </div>
    <!-- main -->
  </div>
</template>

<script setup>
import page_banner from "./page_banner.vue";
import logo_display from "./logo_display.vue";
import tip_card from "./tips_card.vue";
import { computed, onBeforeMount, ref } from "vue";
import api from "@/api/index.js";

const tips = ref([]);
const error = ref(null);

const current_page = ref(1);
const items_per_page = ref(12);

const paginated_tips = computed(() => {
  let start = (current_page.value - 1) * items_per_page.value;
  let end = start + items_per_page.value;
  return tips.value.slice(start, end);
});

onBeforeMount(async () => {
  try {
    let response = await api.get("/api/get_tips");
    tips.value = response.data;
    tips.value.sort((a, b) => {
      a = new Date(a.create_at);
      b = new Date(b.create_at);
      return b - a;
    });
  } catch (err) {
    console.log(err);
    error.value = "網絡錯誤";
  }
});
</script>
